import { swalConfirm } from '../utils/swalHelpers';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Routes, Route, Link, useNavigate, useLocation } from 'react-router-dom';
import { Search, ArrowLeft, FileText, ExternalLink, Plus, Edit2, Trash2, X, Save, BookOpen, Users, Briefcase, Calculator, ClipboardList, Star, Award } from 'lucide-react';
import axios from 'axios';
import '../styles/blog.css';
import InternalDocsTab from '../tabs/InternalDocsTab';
import HDVHub from './HDVHub';
import MarketingHub from './MarketingHub';
import MarketingEditor from '../components/Marketing/MarketingEditor';
import BrandGuidelinePage from './BrandGuidelinePage';
import QuyTrinhSaleDieuHanhPage from './QuyTrinhSaleDieuHanhPage';
import ChinhSachDanhGiaPage from './ChinhSachDanhGiaPage';
import CoCheKpiPage from './CoCheKpiPage';
import MarketingTasks from './MarketingTasks';
import { SOP_META_ADS_MARKDOWN } from '../data/sopMetaAds';
import { BLUEPRINT_META_ADS_MARKDOWN } from '../data/blueprintMetaAds';
import { RULE_META_ADS_MARKDOWN } from '../data/ruleMetaAds';
import { SOP_ASTRO_TOUR_MARKDOWN } from '../data/sopAstroTour';
import { SOP_DISPATCH_MARKDOWN, SOP_SALES_MARKDOWN, SOP_OVERVIEW_MARKDOWN } from '../data/sopDispatchSales';
import { QUY_TRINH_THANH_TOAN_TOUR_MARKDOWN } from '../data/quyTrinhThanhToanTour';
import { QUY_TAC_PHAN_LOAI_LEAD_MARKDOWN } from '../data/quyTacPhanLoaiLead';
import SopMetaAdsInfographic from './SopMetaAdsInfographic';
import RagDocViewer from '../components/Knowledge/RagDocViewer';
import LadakhConsultingPage from './LadakhConsultingPage';
import BhutanConsultingPage from './BhutanConsultingPage';

/* ═══════════════════════════════════════════════════════════════════════════
   Static Document Index — TẤT CẢ tài liệu nội bộ đã biết
   ═══════════════════════════════════════════════════════════════════════════ */
const STATIC_DOCS = [
  { title: 'Brand Identity Guideline', description: 'Tài liệu hướng dẫn nhận diện thương hiệu FIT Tour, bao gồm logo, màu sắc, font chữ...', category: 'Marketing', path: '/tai-lieu/brand-guideline', icon: '🎨' },
  { title: 'HUB Hướng Dẫn Viên', description: 'Bàn làm việc của HDV — checklist, SOP, sự cố, case study', category: 'HDV', path: '/hdv', icon: '👨‍✈️' },
  { title: 'HUB Marketing', description: 'Tài liệu Marketing, chuẩn mực content, format bài đăng & Báo cáo hiệu suất team', category: 'Marketing', path: '/tai-lieu/marketing', icon: '📈' },
  { title: 'Quy Tắc Phân Loại Lead', description: 'Quy tắc dọn dẹp Auto-Fail và Re-open cho Lead Marketing', category: 'Marketing', path: '/tai-lieu/marketing/quy-tac-phan-loai', icon: '🧹' },
  { title: 'SOP Dev: Elementor to Astro', description: 'Quy chuẩn sử dụng Native Astro Components khi migrate (chuyển đổi) các trang Tour cũ từ Elementor sang.', category: 'Dev', path: '/tai-lieu/sop-astro-tour', icon: '💻' },
  { title: 'Rule Meta Ads', description: 'Các quy tắc bắt buộc và khuyến nghị khi thiết lập chiến dịch Meta Ads.', category: 'Marketing', path: '/tai-lieu/rule-meta-ads', icon: '📜' },
  { title: 'Blueprint Meta Ads', description: 'Hướng dẫn chạy quảng cáo Meta (Facebook/IG) chuẩn FIT Tour - Quy tắc đặt tên, target, content và tối ưu.', category: 'Marketing', path: '/tai-lieu/blueprint-meta-ads', icon: '🎯' },
  { title: 'HUB Kinh Doanh (Sale)', description: 'Tài liệu dành cho phòng kinh doanh, quy trình bán hàng', category: 'Sale', path: '/tai-lieu/sale', icon: '💼' },
  { title: 'SOP Sales & Workplace', description: 'Hướng dẫn Sales nhận Lead, cập nhật ERP và tối ưu Workplace', category: 'Sale', path: '/tai-lieu/sop-sales', icon: '💼' },
  { title: 'HUB Điều Hành (OP)', description: 'Quy trình điều hành tour, vận hành dịch vụ', category: 'Điều hành', path: '/tai-lieu/dieu-hanh', icon: '🔧' },
  { title: 'Tổng quan Quy trình Lead', description: 'Bức tranh toàn cảnh về quy trình xử lý Lead từ Điều phối đến Sales', category: 'Điều hành', path: '/tai-lieu/tong-quan-lead', icon: '🌐' },
  { title: 'SOP Điều Phối Lead', description: 'Quy trình tiếp nhận và phân bổ Lead dành cho Trung tâm Điều phối', category: 'Điều hành', path: '/tai-lieu/sop-dieu-phoi', icon: '🔀' },
  { title: 'HUB Kế Toán', description: 'Nghiệp vụ kế toán, quy trình tài chính nội bộ', category: 'Kế toán', path: '/tai-lieu/ke-toan', icon: '📊' },
  { title: 'Quy Trình Thanh Toán & Quyết Toán', description: 'Quy trình thanh toán, bàn giao, quyết toán tour.', category: 'Kế toán', path: '/tai-lieu/quy-trinh-thanh-toan-ban-giao-quyet-toan-tour', icon: '💸' },
  { title: 'Biểu Mẫu Hành Chính', description: 'Giấy phép, biểu mẫu, tài liệu hành chính công ty', category: 'Biểu mẫu', path: '/tai-lieu/bieu-mau', icon: '📋' },
  { title: 'Bộ Nguyên Tắc Hành Xử Nhân Viên Văn Phòng', description: 'Quy tắc ứng xử, giao tiếp, ra quyết định, xử lý sự cố', category: 'Quy tắc', path: '/tai-lieu/bo-nguyen-tac-hanh-xu-nhan-vien', icon: '📓' },
  { title: 'Quy Chế Lương Hướng Dẫn Viên', description: 'Chính sách lương, thưởng, phụ cấp cho HDV', category: 'HDV', path: '/tai-lieu/quy-che-luong-hdv', icon: '💰' },
  { title: 'Quy Trình Sale & Điều Hành', description: 'Nhắc nhở quy trình làm việc giữa Sale & Điều Hành và các lỗi sai thường gặp', category: 'Điều hành', path: '/tai-lieu/quy-trinh-sale-dieu-hanh', icon: '⚠️' },
  { title: 'Overview Đánh Giá FIT Tour', description: 'Tổng quan hệ thống đánh giá hiệu suất và chất lượng dịch vụ HDV', category: 'HDV', path: 'https://drive.google.com/file/d/1s_WBLcpunGLAuHC8JE5MdwPopUR-4Nqe/view', icon: '⭐', external: true },
  { title: 'SOP Hướng Dẫn Viên', description: 'Quy trình chuẩn vận hành dành cho HDV — từ chuẩn bị đến hoàn tất tour', category: 'HDV', path: 'https://drive.google.com/file/d/1ql-COwH3w78L-lHmuKr6D5BaDKz5f46o/view', icon: '📄', external: true },
  { title: 'Giấy Phép Kinh Doanh FIT Tour', description: 'GPKD công ty FIT Tour', category: 'Giấy phép', path: '#', icon: '📜' },
  { title: 'Giấy Phép Lữ Hành Quốc Tế', description: 'GPLH quốc tế FIT Tour', category: 'Giấy phép', path: '#', icon: '📜' },
  { title: 'Checklist Thiết Kế Tour', description: 'Bảng checklist thiết kế sản phẩm tour mới', category: 'Điều hành', path: 'https://docs.google.com/spreadsheets/d/1GcDo5omS19co79Gv3vQ-Naf9v2TudWf9LmMr_w8LFvQ/edit?gid=0#gid=0', icon: '✅', external: true },
  { title: 'SOP Chuẩn Hóa Tên Tour', description: 'Quy chuẩn đặt tên tour trên ERP, Website và Social', category: 'Điều hành', path: '/tai-lieu/dat-ten-tour', icon: '📝' },
  { title: 'Hướng Dẫn Kết Nối Zoho Mail', description: 'Hướng dẫn cài đặt Zoho Mail với Outlook, Apple Mail, Spark (IMAP)', category: 'Hành chính', path: '/tai-lieu/zoho-email', icon: '📧' },
  { title: 'SOP Chính Sách Đánh Giá (Review)', description: 'Điều chỉnh và hướng dẫn chính sách đánh giá trên Google Review', category: 'Marketing', path: '/tai-lieu/chinh-sach-danh-gia', icon: '⭐' },
  { title: 'Hướng Dẫn Đánh Giá FIT TOUR Trên Google Maps', description: 'Hướng dẫn từng bước cách đánh giá 5 sao kèm hình ảnh trên Google Maps FIT TOUR', category: 'HDV', path: 'https://fittour.vn/huong-dan-danh-gia-fit-tour', icon: '⭐', external: true },
  { title: 'Cơ Chế KPI', description: 'Quyết định ban hành cơ chế lương – KPI – thưởng và phúc lợi nhân sự', category: 'Hành chính', path: '/tai-lieu/co-che-kpi', icon: '💼' },
];

/* ═══════════════════════════════════════════════════════════════════════════
   Blog Layout Shell — Dùng chung cho TẤT CẢ trang tài liệu nội bộ
   CSS: blog-wrapper, blog-header, blog-main
   ═══════════════════════════════════════════════════════════════════════════ */
const BlogLayout = ({ children, fullWidth = false, backPath = "/", backText = "Về lại CRM" }) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [bieuMauItems, setBieuMauItems] = useState([]);
  const [ragDocs, setRagDocs] = useState([]);
  const searchRef = useRef(null);
  const inputRef = useRef(null);

  // Fetch biểu mẫu items & rag docs once for search
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.get('/api/licenses', { headers: { Authorization: `Bearer ${token}` } })
        .then(res => setBieuMauItems(res.data))
        .catch(() => {});
    }
    
    // Always fetch RAG docs (backend allows public read for localhost view)
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
    axios.get('/api/rag-docs', config)
      .then(res => setRagDocs(res.data))
      .catch(() => {});
  }, []);

  // Debounced search
  useEffect(() => {
    if (!query.trim()) {
      setResults([]);
      setShowDropdown(false);
      return;
    }

    const timer = setTimeout(() => {
      const q = query.toLowerCase().trim();
      const allDocs = [
        ...STATIC_DOCS,
        ...bieuMauItems.map(item => ({
          title: item.name,
          description: item.description || 'Biểu mẫu văn phòng',
          category: 'Biểu mẫu',
          path: item.link || '/tai-lieu/bieu-mau',
          icon: '📋',
          external: item.link ? !item.link.startsWith('/') : false,
        })),
        ...ragDocs.filter(d => d.status === 'active').map(doc => ({
          title: doc.title,
          description: doc.content_text ? doc.content_text.substring(0, 50) + '...' : 'Tài liệu nội bộ',
          category: doc.category || 'Khác',
          path: (doc.content_type === 'link_drive' || doc.content_type === 'link_image') ? doc.attachment_url : `/tai-lieu/${doc.id}`,
          icon: doc.content_type === 'text' ? '📝' : '🔗',
          external: (doc.content_type === 'link_drive' || doc.content_type === 'link_image'),
          target_bus: doc.target_bus
        }))
      ];

      const matched = allDocs.filter(doc =>
        doc.title.toLowerCase().includes(q) ||
        doc.description.toLowerCase().includes(q) ||
        doc.category.toLowerCase().includes(q)
      ).slice(0, 8); // Max 8 results

      setResults(matched);
      setShowDropdown(true);
      setActiveIndex(-1);
    }, 200); // 200ms debounce

    return () => clearTimeout(timer);
  }, [query, bieuMauItems]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Navigate to selected result
  const handleSelect = useCallback((doc) => {
    setShowDropdown(false);
    setQuery('');
    if (doc.external) {
      window.open(doc.path, '_blank');
    } else {
      navigate(doc.path);
    }
  }, [navigate]);

  // Keyboard navigation
  const handleKeyDown = (e) => {
    if (!showDropdown) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActiveIndex(prev => (prev < results.length - 1 ? prev + 1 : 0));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActiveIndex(prev => (prev > 0 ? prev - 1 : results.length - 1));
    } else if (e.key === 'Enter' && activeIndex >= 0) {
      e.preventDefault();
      handleSelect(results[activeIndex]);
    } else if (e.key === 'Escape') {
      setShowDropdown(false);
      inputRef.current?.blur();
    }
  };

  return (
    <div className="blog-wrapper">
      <header className="blog-header">
        <div className="blog-header-content">
          <div className="blog-logo">
            <img src="/logo.png" alt="FIT Tour" />
          </div>
          <div className="blog-search" ref={searchRef}>
            <div className="blog-search-input-wrapper">
              <Search size={16} className="blog-search-icon" />
              <input 
                ref={inputRef}
                type="text" 
                placeholder="Tìm kiếm tài liệu, SOP, biểu mẫu..." 
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onFocus={() => query.trim() && results.length > 0 && setShowDropdown(true)}
                onKeyDown={handleKeyDown}
                autoComplete="off"
              />
              {query && (
                <button className="blog-search-clear" onClick={() => { setQuery(''); setShowDropdown(false); inputRef.current?.focus(); }}>
                  <X size={14} />
                </button>
              )}
            </div>

            {/* Search Results Dropdown */}
            {showDropdown && (
              <div className="blog-search-dropdown">
                {results.length > 0 && (
                  <div className="blog-search-dropdown-header">
                    <span>Kết quả ({results.length})</span>
                    <span className="blog-search-hint">↑↓ di chuyển · Enter chọn · Esc đóng</span>
                  </div>
                )}
                {results.length === 0 && (
                  <div className="blog-search-no-results">
                    <Search size={20} style={{ opacity: 0.3 }} />
                    <span>Không tìm thấy kết quả cho "{query}"</span>
                  </div>
                )}
                {results.map((doc, idx) => (
                  <div 
                    key={idx} 
                    className={`blog-search-result ${idx === activeIndex ? 'active' : ''}`}
                    onClick={() => handleSelect(doc)}
                    onMouseEnter={() => setActiveIndex(idx)}
                  >
                    <span className="blog-search-result-icon">{doc.icon}</span>
                    <div className="blog-search-result-info">
                      <div className="blog-search-result-title">
                        {doc.title}
                        {doc.external && <ExternalLink size={12} style={{ marginLeft: 4, opacity: 0.5 }} />}
                        {doc.target_bus && doc.target_bus.length > 0 && (
                            <span style={{ marginLeft: 8, fontSize: '0.65rem', background: '#8b5cf6', color: 'white', padding: '2px 6px', borderRadius: '6px', fontWeight: 600 }}>{doc.target_bus.join(', ')}</span>
                        )}
                      </div>
                      <div className="blog-search-result-desc">{doc.description}</div>
                    </div>
                    <span className="blog-search-result-cat">{doc.category}</span>
                  </div>
                ))}
              </div>
            )}


          </div>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            <Link to="/tai-lieu/manager" className="blog-back-btn" style={{ background: '#3b82f6', color: 'white', border: 'none' }}>
              <Edit2 size={16} /> Quản lý bài viết
            </Link>
            <Link to={backPath} className="blog-back-btn">
              <ArrowLeft size={16} /> {backText}
            </Link>
          </div>
        </div>
      </header>
      
      <main className="blog-main" style={fullWidth ? { padding: 0, margin: 0, maxWidth: '100%' } : {}}>
        {children}
      </main>
    </div>
  );
};


/* ═══════════════════════════════════════════════════════════════════════════
   Biểu Mẫu Văn Phòng Sub-page
   ═══════════════════════════════════════════════════════════════════════════ */
const BieuMauPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({ name: '', link: '', description: '' });

  // Check role from localStorage token
  const currentUser = (() => {
    try { return JSON.parse(atob(localStorage.getItem('token')?.split('.')[1] || '{}')); } catch { return {}; }
  })();
  const canEdit = ['admin', 'manager'].includes(currentUser?.role);

  const fetchItems = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const res = await axios.get('/api/licenses', { headers: { Authorization: `Bearer ${token}` } });
      setItems(res.data);
    } catch (err) {
      console.error('Lỗi tải biểu mẫu:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchItems(); }, []);

  const handleSave = async () => {
    if (!formData.name.trim()) return alert('Tên là bắt buộc!');
    try {
      const token = localStorage.getItem('token');
      const config = { headers: { Authorization: `Bearer ${token}` } };
      if (editingItem) {
        await axios.put(`/api/licenses/${editingItem.id}`, formData, config);
      } else {
        await axios.post('/api/licenses', formData, config);
      }
      setShowModal(false);
      setEditingItem(null);
      setFormData({ name: '', link: '', description: '' });
      fetchItems();
    } catch (err) {
      alert('Lỗi: ' + (err.response?.data?.message || err.message));
    }
  };

  const handleDelete = async (id) => {
    if (!await swalConfirm('Xóa biểu mẫu này?')) return;
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`/api/licenses/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      fetchItems();
    } catch (err) {
      alert('Lỗi: ' + (err.response?.data?.message || err.message));
    }
  };

  const filtered = items.filter(l => 
    l.name.toLowerCase().includes(search.toLowerCase()) || 
    (l.description && l.description.toLowerCase().includes(search.toLowerCase()))
  );

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
  };

  return (
    <BlogLayout>
      <div style={{ maxWidth: 900, margin: '0 auto' }}>
        {/* Breadcrumb */}
        <Link to="/tai-lieu" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: '#f97316', fontWeight: 700, textDecoration: 'none', marginBottom: '1.5rem' }}>
          <ArrowLeft size={16} /> Quay lại trang chủ Tài Liệu
        </Link>

        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '2rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 48, height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(99,102,241,0.3)' }}>
              <FileText size={24} color="white" />
            </div>
            <div>
              <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 800, color: '#0f172a' }}>Biểu Mẫu Văn Phòng</h1>
              <p style={{ margin: 0, fontSize: '0.85rem', color: '#64748b' }}>Danh sách biểu mẫu, giấy phép & tài liệu nội bộ</p>
            </div>
          </div>
          {canEdit && (
            <button onClick={() => { setEditingItem(null); setFormData({ name: '', link: '', description: '' }); setShowModal(true); }} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '10px 20px', borderRadius: 10, background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', color: 'white', border: 'none', fontWeight: 700, fontSize: '0.9rem', cursor: 'pointer', boxShadow: '0 4px 12px rgba(99,102,241,0.3)', transition: 'transform 0.2s' }}>
              <Plus size={18} /> Thêm Biểu Mẫu
            </button>
          )}
        </div>

        {/* Search */}
        <div style={{ position: 'relative', marginBottom: '1.5rem' }}>
          <Search size={18} style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }} />
          <input
            type="text" placeholder="Tìm kiếm biểu mẫu, giấy phép (hỗ trợ tìm theo mô tả)..."
            value={search} onChange={e => setSearch(e.target.value)}
            style={{ width: '100%', padding: '12px 14px 12px 42px', borderRadius: 10, border: '1px solid #e2e8f0', fontSize: '0.9rem', outline: 'none', background: 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.04)', transition: 'border 0.2s' }}
          />
        </div>

        {/* List */}
        <div style={{ background: 'white', borderRadius: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
          {loading ? (
            <div style={{ padding: '3rem', textAlign: 'center', color: '#94a3b8' }}>Đang tải biểu mẫu...</div>
          ) : filtered.length === 0 ? (
            <div style={{ padding: '3rem', textAlign: 'center', color: '#94a3b8' }}>Không tìm thấy biểu mẫu nào.</div>
          ) : filtered.map((item, idx) => (
            <div key={item.id} style={{ display: 'flex', alignItems: 'flex-start', gap: 14, padding: '16px 24px', borderBottom: idx < filtered.length - 1 ? '1px solid #f1f5f9' : 'none', transition: 'background 0.15s', cursor: 'default' }}
              onMouseOver={e => e.currentTarget.style.background = '#faf5ff'}
              onMouseOut={e => e.currentTarget.style.background = 'white'}
            >
              <div style={{ width: 36, height: 36, borderRadius: 8, background: '#f0f0ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 2 }}>
                <FileText size={18} color="#6366f1" />
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, color: '#1e293b', fontSize: '0.95rem' }}>{item.name}</div>
                {item.description && (
                  <div style={{ fontSize: '0.85rem', color: '#64748b', marginTop: 4, lineHeight: 1.4 }}>{item.description}</div>
                )}
                {item.updated_at && (
                  <div style={{ fontSize: '0.75rem', color: '#94a3b8', marginTop: 6 }}>
                    Cập nhật: {formatDate(item.updated_at)}
                  </div>
                )}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
                {item.link ? (
                  <a href={item.link} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '6px 16px', borderRadius: 8, background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', color: 'white', fontSize: '0.8rem', fontWeight: 600, textDecoration: 'none', transition: 'opacity 0.2s' }}>
                    <ExternalLink size={14} /> Mở
                  </a>
                ) : (
                  <span style={{ color: '#cbd5e1', fontSize: '0.8rem' }}>Chưa có link</span>
                )}
                {canEdit && (
                  <>
                    <button title="Sửa" onClick={() => { setEditingItem(item); setFormData({ name: item.name, link: item.link || '', description: item.description || '' }); setShowModal(true); }} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6366f1', padding: 4 }}>
                      <Edit2 size={15} />
                    </button>
                    <button title="Xóa" onClick={() => handleDelete(item.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', padding: 4 }}>
                      <Trash2 size={15} />
                    </button>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Modal */}
        {showModal && (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15,23,42,0.6)', backdropFilter: 'blur(4px)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ background: 'white', borderRadius: 16, padding: '2rem', width: 500, maxWidth: '90%', boxShadow: '0 25px 50px rgba(0,0,0,0.25)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
                <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 700 }}>{editingItem ? 'Chỉnh sửa Biểu mẫu' : 'Thêm Biểu mẫu mới'}</h3>
                <button onClick={() => setShowModal(false)} style={{ background: '#f1f5f9', border: 'none', borderRadius: '50%', width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}><X size={16} /></button>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <div>
                  <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#475569', display: 'block', marginBottom: 6 }}>Tên biểu mẫu / tài liệu *</label>
                  <input type="text" value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} placeholder="VD: Mẫu đơn xin phép..." style={{ width: '100%', padding: '10px 14px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: 14, outline: 'none' }} />
                </div>
                <div>
                  <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#475569', display: 'block', marginBottom: 6 }}>
                    Mô tả ngắn <span style={{ fontWeight: 400, color: '#94a3b8' }}>(Tối đa 150 ký tự)</span>
                  </label>
                  <textarea 
                    value={formData.description} 
                    onChange={e => setFormData({ ...formData, description: e.target.value })} 
                    placeholder="Mô tả nội dung để dễ tìm kiếm sau này..." 
                    maxLength={150}
                    rows={3}
                    style={{ width: '100%', padding: '10px 14px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: 14, outline: 'none', resize: 'none' }} 
                  />
                  <div style={{ fontSize: '0.75rem', color: '#94a3b8', textAlign: 'right', marginTop: 4 }}>
                    {formData.description.length}/150
                  </div>
                </div>
                <div>
                  <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#475569', display: 'block', marginBottom: 6 }}>Link tài liệu (Drive, URL...)</label>
                  <input type="url" value={formData.link} onChange={e => setFormData({ ...formData, link: e.target.value })} placeholder="https://drive.google.com/..." style={{ width: '100%', padding: '10px 14px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: 14, outline: 'none' }} />
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.75rem', marginTop: '1.5rem' }}>
                <button onClick={() => setShowModal(false)} style={{ padding: '8px 20px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#f8fafc', color: '#475569', fontWeight: 600, cursor: 'pointer' }}>Hủy</button>
                <button onClick={handleSave} style={{ padding: '8px 20px', borderRadius: 8, border: 'none', background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', color: 'white', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}>
                  <Save size={16} /> Lưu
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </BlogLayout>
  );
};

/* ═══════════════════════════════════════════════════════════════════════════
   Documents Home Page
   CSS: blog-top-cards, blog-welcome, blog-columns
   ═══════════════════════════════════════════════════════════════════════════ */
const DocumentsHome = () => {
  const [licenses, setLicenses] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.get('/api/licenses', { headers: { Authorization: `Bearer ${token}` } })
        .then(res => setLicenses(res.data))
        .catch(() => {});
    }
  }, []);

  // Popup: hiện 1 lần / user, hết hạn sau ngày 06/06/2026
  useEffect(() => {
    const POPUP_KEY = 'popup_chinh_sach_review_hdv_seen';
    const EXPIRE_DATE = new Date('2026-06-07T00:00:00+07:00'); // hết hạn đầu ngày 7/6
    const now = new Date();
    if (now < EXPIRE_DATE && !localStorage.getItem(POPUP_KEY)) {
      // Delay nhẹ cho trang load xong mới hiện popup
      const timer = setTimeout(() => setShowPopup(true), 600);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClosePopup = () => {
    localStorage.setItem('popup_chinh_sach_review_hdv_seen', '1');
    setShowPopup(false);
  };

  // Tìm link theo tên từ danh sách biểu mẫu
  const findLink = (keyword) => {
    const item = licenses.find(l => l.name.toLowerCase().includes(keyword.toLowerCase()));
    return item?.link || '#';
  };

  return (
    <BlogLayout>
      <div className="doc-wp-home">

      {/* ═══ Popup thông báo Chính sách Review HDV ═══ */}
      {showPopup && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 9999,
          background: 'rgba(15, 23, 42, 0.55)', backdropFilter: 'blur(4px)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          animation: 'sopPopupFadeIn 0.3s ease-out'
        }} onClick={handleClosePopup}>
          <style>{`
            @keyframes sopPopupFadeIn {
              from { opacity: 0; }
              to   { opacity: 1; }
            }
            @keyframes sopPopupSlideUp {
              from { opacity: 0; transform: translateY(30px) scale(0.97); }
              to   { opacity: 1; transform: translateY(0) scale(1); }
            }
          `}</style>

          <div onClick={e => e.stopPropagation()} style={{
            background: '#fff', borderRadius: '20px', width: '92%', maxWidth: '460px',
            boxShadow: '0 25px 60px -12px rgba(0,0,0,0.25)',
            overflow: 'hidden',
            animation: 'sopPopupSlideUp 0.35s ease-out'
          }}>
            {/* Header gradient */}
            <div style={{
              background: 'linear-gradient(135deg, #e55e20 0%, #f97316 100%)',
              padding: '28px 28px 22px', color: 'white', position: 'relative'
            }}>
              <button onClick={handleClosePopup} style={{
                position: 'absolute', top: '12px', right: '12px',
                background: 'rgba(255,255,255,0.2)', border: 'none',
                borderRadius: '50%', width: '30px', height: '30px',
                color: 'white', cursor: 'pointer', fontSize: '18px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                transition: 'background 0.2s'
              }} onMouseOver={e => e.currentTarget.style.background = 'rgba(255,255,255,0.35)'}
                 onMouseOut={e => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}>
                ✕
              </button>
              <div style={{ fontSize: '2rem', marginBottom: '6px' }}>📢</div>
              <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 800, lineHeight: 1.3 }}>
                Thông báo Chính sách mới
              </h3>
              <p style={{ margin: '6px 0 0', fontSize: '0.85rem', opacity: 0.9, fontWeight: 500 }}>
                Có hiệu lực từ 01/05/2026
              </p>
            </div>

            {/* Body */}
            <div style={{ padding: '24px 28px 28px' }}>
              <h4 style={{ margin: '0 0 12px', fontSize: '1.05rem', fontWeight: 700, color: '#1e293b' }}>
                🎯 Quy chế Thưởng Đánh giá Review (HDV)
              </h4>
              <p style={{ margin: '0 0 8px', fontSize: '0.92rem', color: '#475569', lineHeight: 1.65 }}>
                Công ty điều chỉnh cơ chế hạch toán chi phí thưởng đối với các đánh giá <strong style={{ color: '#e55e20' }}>5 sao trên Google Review</strong> — áp dụng cho Tour Leader và Hướng Dẫn Viên.
              </p>
              <div style={{
                background: '#fff7ed', borderRadius: '10px', padding: '12px 14px',
                marginBottom: '20px', fontSize: '0.85rem', color: '#92400e', lineHeight: 1.55
              }}>
                <div style={{ marginBottom: '4px' }}>⭐ Review 5* + 05 hình → <strong>100.000đ / review</strong></div>
                <div>⭐ Review 5* + 10 hình → <strong>150.000đ / review</strong></div>
              </div>

              <Link to="/tai-lieu/chinh-sach-danh-gia" onClick={handleClosePopup}
                style={{
                  display: 'block', textAlign: 'center', textDecoration: 'none',
                  background: 'linear-gradient(135deg, #e55e20, #f97316)',
                  color: 'white', padding: '13px 24px', borderRadius: '12px',
                  fontWeight: 700, fontSize: '0.95rem',
                  boxShadow: '0 4px 14px rgba(229, 94, 32, 0.35)',
                  transition: 'transform 0.15s, box-shadow 0.15s'
                }}
                onMouseOver={e => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(229,94,32,0.45)'; }}
                onMouseOut={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 14px rgba(229,94,32,0.35)'; }}
              >
                Xem chi tiết chính sách →
              </Link>
              <div style={{ marginTop: '12px', textAlign: 'center' }}>
                <a href="https://fittour.vn/huong-dan-danh-gia-fit-tour" target="_blank" rel="noreferrer"
                  style={{ fontSize: '0.85rem', color: '#e55e20', textDecoration: 'none', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                  <span>📍</span> Hướng dẫn khách đánh giá Google Maps &rarr;
                </a>
              </div>
              <p style={{ margin: '14px 0 0', textAlign: 'center', fontSize: '0.78rem', color: '#94a3b8' }}>
                Thông báo này chỉ hiện một lần
              </p>
            </div>
          </div>
        </div>
      )}
        {/* 5 Hubs */}
        <div className="blog-top-cards">
          <div className="blog-top-card" style={{ background: 'linear-gradient(to right, #f8fafc, #f1f5f9)', display: 'block', padding: '1.25rem' }}>
            <Link to="/hdv" style={{ display: 'flex', alignItems: 'center', gap: '1rem', textDecoration: 'none', color: '#1e293b' }}>
              <img src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png" alt="HDV" className="blog-icon-img" />
              <span style={{ fontWeight: 600 }}>HUB Hướng Dẫn Viên</span>
            </Link>
            <hr style={{ border: 'none', borderTop: '1px solid #e2e8f0', margin: '0.75rem 0' }} />
            <ul className="blog-list">
              <li style={{ marginBottom: '0.5rem' }}>
                <Link to="/tai-lieu/quy-che-luong-hdv" style={{ fontSize: '0.85rem' }}><span className="blog-list-icon" style={{ fontSize: '1rem' }}>💰</span> Quy chế lương Hướng Dẫn Viên</Link>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <Link to="/tai-lieu/chinh-sach-danh-gia" style={{ fontSize: '0.85rem' }}><span className="blog-list-icon" style={{ fontSize: '1rem' }}>⭐</span> Chính sách Review HDV</Link>
              </li>
              <li style={{ marginBottom: 0 }}>
                <a href="https://fittour.vn/huong-dan-danh-gia-fit-tour" target="_blank" rel="noreferrer" style={{ fontSize: '0.85rem' }}>
                  <span className="blog-list-icon" style={{ fontSize: '1rem' }}>📍</span> Hướng dẫn đánh giá Google Maps
                </a>
              </li>
            </ul>
          </div>
          <Link to="/tai-lieu/marketing" className="blog-top-card">
            <img src="https://cdn-icons-png.flaticon.com/512/1998/1998087.png" alt="Marketing" className="blog-icon-img" />
            <span>HUB Marketing</span>
          </Link>
          <div className="blog-top-card" style={{ background: 'linear-gradient(to right, #f8fafc, #f1f5f9)', display: 'block', padding: '1.25rem' }}>
            <Link to="/tai-lieu/sale" style={{ display: 'flex', alignItems: 'center', gap: '1rem', textDecoration: 'none', color: '#1e293b' }}>
              <img src="https://cdn-icons-png.flaticon.com/512/3135/3135673.png" alt="Sale" className="blog-icon-img" />
              <span style={{ fontWeight: 600 }}>HUB Kinh Doanh (Sale)</span>
            </Link>
            <hr style={{ border: 'none', borderTop: '1px solid #e2e8f0', margin: '0.75rem 0' }} />
            <ul className="blog-list">
              <li style={{ marginBottom: '0.5rem' }}>
                <Link to="/tai-lieu/tu-van-ladakh-bu4" style={{ fontSize: '0.85rem' }}><span className="blog-list-icon" style={{ fontSize: '1rem' }}>🏔️</span> Cẩm nang chốt sale Ladakh (BU4)</Link>
              </li>
              <li style={{ marginBottom: 0 }}>
                <Link to="/tai-lieu/tu-van-bhutan-5n4d" style={{ fontSize: '0.85rem' }}><span className="blog-list-icon" style={{ fontSize: '1rem' }}>⛩️</span> Cẩm nang chốt sale Bhutan (5N4Đ)</Link>
              </li>
            </ul>
          </div>
          <div className="blog-top-card" style={{ background: 'linear-gradient(to right, #f8fafc, #f1f5f9)', display: 'block', padding: '1.25rem' }}>
            <Link to="/tai-lieu/dieu-hanh" style={{ display: 'flex', alignItems: 'center', gap: '1rem', textDecoration: 'none', color: '#1e293b' }}>
              <img src="https://cdn-icons-png.flaticon.com/512/2830/2830305.png" alt="Điều hành" className="blog-icon-img" />
              <span style={{ fontWeight: 600 }}>HUB Điều Hành (OP)</span>
            </Link>
            <hr style={{ border: 'none', borderTop: '1px solid #e2e8f0', margin: '0.75rem 0' }} />
            <ul className="blog-list">
              <li style={{ marginBottom: 0 }}>
                <Link to="/tai-lieu/quy-trinh-thanh-toan-ban-giao-quyet-toan-tour" style={{ fontSize: '0.85rem' }}><span className="blog-list-icon" style={{ fontSize: '1rem' }}>💸</span> Thanh toán, bàn giao, quyết toán</Link>
              </li>
            </ul>
          </div>
          <Link to="/cam-nang-thuong-hieu" className="blog-top-card">
            <img src="https://cdn-icons-png.flaticon.com/512/3067/3067261.png" alt="Thương hiệu" className="blog-icon-img" />
            <span>Cẩm Nang Thương Hiệu</span>
          </Link>
          <Link to="/tai-lieu/ke-toan" className="blog-top-card">
            <img src="https://cdn-icons-png.flaticon.com/512/3135/3135690.png" alt="Kế toán" className="blog-icon-img" />
            <span>HUB Kế Toán</span>
          </Link>
        </div>
        {/* Welcome Block */}
        <div className="blog-welcome">
          <p>👋 <span className="blog-text-orange">Chào mừng các chiến binh FIT TOUR!</span> Đây là <strong>không gian làm việc chung</strong> dành riêng cho đội ngũ Fit Tour – nơi <span className="blog-text-orange">lưu trữ thông tin, kết nối nội bộ</span> và <span className="blog-text-orange">hỗ trợ bạn chủ động trong công việc</span> mỗi ngày.</p>
          <p style={{ marginTop: '0.75rem' }}>👉 Mục tiêu của chúng ta: <span className="blog-text-orange">làm việc hiệu quả hơn – năng suất cao hơn – thu nhập tốt hơn</span>.</p>
        </div>

        {/* 3 Columns */}
        <div className="blog-columns">
          {/* Col 1 */}
          <div className="blog-column">
            <h2 className="blog-col-title">Hồ sơ công ty</h2>
            
            <h3 className="blog-section-title">Giấy phép hoạt động</h3>
            <ul className="blog-list">
              <li><a href={findLink('GPKD')} target="_blank" rel="noreferrer"><span className="blog-list-icon">📓</span> Giấy phép kinh doanh FIT Tour</a></li>
              <li><a href={findLink('GPLH')} target="_blank" rel="noreferrer"><span className="blog-list-icon">📓</span> Giấy phép lữ hành quốc tế</a></li>
            </ul>

            <h3 className="blog-section-title" style={{ marginTop: '2rem' }}>Hồ sơ doanh nghiệp</h3>
            <ul className="blog-list">
              <li><a href="https://dulichcoguu.com/portfolio/" target="_blank" rel="noreferrer"><span className="blog-list-icon">📓</span> Portfolio</a></li>
              <li><a href="https://dulichcoguu.com/our-team/" target="_blank" rel="noreferrer"><span className="blog-list-icon">📓</span> Our Team</a></li>
              <li><a href="https://dulichcoguu.com/diem-den-fit-tour/" target="_blank" rel="noreferrer"><span className="blog-list-icon">📓</span> Địa điểm và dự án FIT Tour</a></li>
            </ul>
          </div>

          {/* Col 2 */}
          <div className="blog-column">
            <h2 className="blog-col-title">Checklist Điều Hành</h2>
            
            <h3 className="blog-section-title">Giấy phép hoạt động</h3>
            <ul className="blog-list">
              <li><a href="https://docs.google.com/spreadsheets/d/1GcDo5omS19co79Gv3vQ-Naf9v2TudWf9LmMr_w8LFvQ/edit?gid=0#gid=0" target="_blank" rel="noreferrer"><span className="blog-list-icon">📓</span> Checklist Thiết kế tour</a></li>
            </ul>

            <h3 className="blog-section-title" style={{ marginTop: '2rem' }}>Quy chuẩn & SOP</h3>
            <ul className="blog-list">
              <li><Link to="/tai-lieu/dat-ten-tour"><span className="blog-list-icon">📓</span> SOP – Chuẩn hóa tên Tour</Link></li>
            </ul>
          </div>

          {/* Col 3 */}
          <div className="blog-column">
            <h2 className="blog-col-title">Quy tắc hành xử</h2>
            
            <ul className="blog-list" style={{ marginTop: '1.5rem' }}>
              <li><Link to="/tai-lieu/bo-nguyen-tac-hanh-xu-nhan-vien"><span className="blog-list-icon">📓</span> Bộ quy tắc hành xử Nhân viên văn phòng</Link></li>
              <li><Link to="/tai-lieu/quy-trinh-sale-dieu-hanh"><span className="blog-list-icon">📓</span> Nhắc nhở quy trình làm việc Sale & Điều Hành</Link></li>
            </ul>

            <h3 className="blog-section-title" style={{ marginTop: '2rem' }}>Hướng dẫn Công cụ</h3>
            <ul className="blog-list">
              <li><Link to="/tai-lieu/zoho-email"><span className="blog-list-icon">📧</span> Hướng Dẫn Kết Nối Zoho Mail</Link></li>
              <li>
                <a href="https://fittour.vn/huong-dan-danh-gia-fit-tour" target="_blank" rel="noreferrer">
                  <span className="blog-list-icon">⭐</span> Hướng Dẫn Đánh Giá Google Maps
                </a>
              </li>
            </ul>
          </div>

          {/* Col 4: Biểu mẫu hành chính tự động lấy từ DB */}
          <div className="blog-column">
            <h2 className="blog-col-title">Biểu mẫu hành chính</h2>
            
            <ul className="blog-list" style={{ marginTop: '1.5rem' }}>
              {licenses.map(l => (
                <li key={l.id}>
                  <a href={l.link || '#'} target="_blank" rel="noreferrer">
                    <span className="blog-list-icon">📋</span> {l.name}
                  </a>
                </li>
              ))}
              {licenses.length === 0 && (
                <li style={{ color: '#94a3b8', fontSize: '0.9rem', fontStyle: 'italic' }}>Đang tải biểu mẫu...</li>
              )}
            </ul>
            <div style={{ marginTop: '1.5rem', textAlign: 'left' }}>
              <Link to="/tai-lieu/bieu-mau" style={{ fontSize: '0.85rem', color: '#6366f1', textDecoration: 'none', fontWeight: 600 }}>Quản lý biểu mẫu &rarr;</Link>
            </div>
          </div>
        </div>
      </div>
    </BlogLayout>
  );
};

const PlaceholderPage = () => {
  return (
    <BlogLayout>
      <div style={{ textAlign: 'center', padding: '5rem', background: 'white', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
        <h2>Nội dung đang được cập nhật</h2>
        <p style={{ marginTop: '1rem', color: '#666' }}>Tài liệu này sẽ sớm được tải lên hệ thống.</p>
        <Link to="/tai-lieu" style={{ display: 'inline-block', marginTop: '2rem', color: '#f97316', fontWeight: 'bold', textDecoration: 'none' }}>&larr; Quay lại trang chủ Tài Liệu</Link>
      </div>
    </BlogLayout>
  );
};

/* ═══════════════════════════════════════════════════════════════════════════
   MarkdownViewer — Article Reader with TOC + Scrollspy + Breadcrumb + Meta
   CSS: blog-reader-wrapper, blog-toc, blog-body, blog-prose, blog-meta,
        blog-breadcrumb, blog-back-to-top
   ═══════════════════════════════════════════════════════════════════════════ */
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { ChevronUp, User, Calendar, Clock, ChevronRight } from 'lucide-react';

const MarkdownViewer = ({ fileUrl, markdownContent, title, author, updatedDate, breadcrumbs, quickLinks }) => {
  const location = useLocation();
  const [content, setContent] = useState(markdownContent || '');
  const [loading, setLoading] = useState(!markdownContent);
  const [activeHeadingId, setActiveHeadingId] = useState('');
  const [showBackToTop, setShowBackToTop] = useState(false);
  const headingIdsRef = useRef([]);

  useEffect(() => {
    if (markdownContent) {
      setContent(markdownContent);
      setLoading(false);
      return;
    }
    setLoading(true);
    fetch(fileUrl)
      .then(res => res.text())
      .then(text => {
        setContent(text);
        setLoading(false);
      })
      .catch(() => {
        setContent('# Lỗi\nKhông thể tải tài liệu này.');
        setLoading(false);
      });
  }, [fileUrl, markdownContent]);

  // Lấy danh sách các Chương (Heading 1 và 2) để làm Mục lục
  const headings = content.split('\n')
    .filter(line => line.match(/^#{1,2}\s/))
    .map(line => line.replace(/^#{1,2}\s/, '').trim());

  // Hàm tạo ID từ text để scroll tới
  const generateId = useCallback((text) => {
    if (!text) return '';
    return text.toString().toLowerCase()
      .replace(/đ/g, 'd')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, "") // remove accents
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }, []);

  // Tính thời gian đọc ước tính (200 từ/phút cho tiếng Việt)
  const readingTime = Math.max(1, Math.ceil(content.split(/\s+/).length / 200));

  // ── Scrollspy: theo dõi heading nào đang hiển thị trên viewport ──
  useEffect(() => {
    if (loading || headings.length === 0) return;

    // Cần delay nhỏ để DOM render xong các heading
    const timer = setTimeout(() => {
      headingIdsRef.current = headings.map(h => generateId(h));
    }, 300);

    const handleScroll = () => {
      // Back to Top visibility
      setShowBackToTop(window.scrollY > 400);

      // Scrollspy
      const ids = headingIdsRef.current;
      if (ids.length === 0) return;

      let currentId = '';
      for (let i = ids.length - 1; i >= 0; i--) {
        const el = document.getElementById(ids[i]);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 150) {
            currentId = ids[i];
            break;
          }
        }
      }
      setActiveHeadingId(currentId);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // initial check

    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [loading, headings, generateId]);

  const scrollToHeading = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <BlogLayout>
      <div className="blog-reader-wrapper">
        
        {/* Sidebar: Mục Lục với Scrollspy */}
        <div className="blog-toc">
          {quickLinks && quickLinks.length > 0 && (
            <div className="blog-quick-links" style={{ marginBottom: '24px', paddingBottom: '16px', borderBottom: '1px solid #e2e8f0' }}>
              <h3 className="blog-toc-title" style={{ color: '#0ea5e9' }}>Tài Liệu Liên Quan</h3>
              <ul className="blog-toc-list">
                {quickLinks.map((link, index) => {
                  const isActive = location.pathname === link.path;
                  return (
                    <li key={index} className={`blog-toc-item ${isActive ? 'active' : ''}`}>
                      <Link to={link.path} className={`blog-toc-btn ${isActive ? 'active' : ''}`} style={{ display: 'flex', alignItems: 'center', gap: '8px', textAlign: 'left', width: '100%' }}>
                        {link.icon && <span>{link.icon}</span>}
                        <span style={{ fontWeight: isActive ? '600' : 'normal', lineHeight: '1.4' }}>{link.title}</span>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          <h3 className="blog-toc-title">Nội Dung Bài Viết</h3>
          <ul className="blog-toc-list">
            <li className={`blog-toc-item ${!activeHeadingId ? 'active' : ''}`}>
              <button className={`blog-toc-btn ${!activeHeadingId ? 'active' : ''}`} onClick={scrollToTop}>
                <span className="blog-toc-arrow">&rsaquo;</span> <strong>{title}</strong>
              </button>
            </li>
            {headings.map((heading, index) => {
              const hId = generateId(heading);
              const isActive = activeHeadingId === hId;
              return (
                <li key={index} className={`blog-toc-item ${isActive ? 'active' : ''}`}>
                  <button className={`blog-toc-btn ${isActive ? 'active' : ''}`} onClick={() => scrollToHeading(hId)}>
                    <span className="blog-toc-arrow">&rsaquo;</span> {heading}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
        
        {/* Main Content */}
        <div className="blog-body">
          {/* Breadcrumb */}
          <nav className="blog-breadcrumb">
            <Link to="/tai-lieu">Trang chủ Tài Liệu</Link>
            {breadcrumbs && breadcrumbs.map((bc, i) => (
              <React.Fragment key={i}>
                <ChevronRight size={14} className="blog-breadcrumb-separator" />
                {bc.to ? <Link to={bc.to}>{bc.label}</Link> : <span>{bc.label}</span>}
              </React.Fragment>
            ))}
            <ChevronRight size={14} className="blog-breadcrumb-separator" />
            <span className="blog-breadcrumb-current">{title}</span>
          </nav>


          {loading ? (
            <p>Đang tải tài liệu...</p>
          ) : (
            <div className="blog-prose">
              <ReactMarkdown 
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw]}
                components={{
                  h1: ({node, children, ...props}) => {
                     const text = Array.isArray(children) ? children[0] : children;
                     const id = typeof text === 'string' ? generateId(text) : '';
                     return <h1 id={id} {...props}>{children}</h1>;
                  },
                  a: ({node, href, children, ...props}) => {
                    if (href && (href.includes('youtube.com') || href.includes('youtu.be'))) {
                      // Extract video ID safely
                      let videoId = '';
                      if (href.includes('youtu.be/')) videoId = href.split('youtu.be/')[1].split('?')[0];
                      else if (href.includes('youtube.com/embed/')) videoId = href.split('youtube.com/embed/')[1].split('?')[0];
                      else if (href.includes('youtube.com/watch')) videoId = new URLSearchParams(href.split('?')[1]).get('v');

                      if (videoId) {
                        return (
                          <div className="blog-video-wrapper">
                            <iframe 
                              src={`https://www.youtube.com/embed/${videoId}`} 
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                              allowFullScreen
                              title="YouTube Video"
                            />
                          </div>
                        );
                      }
                    }
                    return <a href={href} {...props}>{children}</a>;
                  }
                }}
              >
                {content}
              </ReactMarkdown>
            </div>
          )}
        </div>

      </div>

      {/* Back to Top Button */}
      <button 
        className={`blog-back-to-top ${showBackToTop ? 'visible' : ''}`}
        onClick={scrollToTop}
        aria-label="Về đầu trang"
      >
        <ChevronUp size={24} />
      </button>
    </BlogLayout>
  );
};

/* ═══════════════════════════════════════════════════════════════════════════
   Router
   ═══════════════════════════════════════════════════════════════════════════ */
// Removing SaleDocsPage component as it is replaced by a static page



const DocumentsPage = () => {
  const location = useLocation();
  const path = location.pathname;

  if (path === '/tai-lieu/bieu-mau') return <BieuMauPage />;
  if (path.startsWith('/hdv')) return <HDVHub />;
  if (path === '/tai-lieu/marketing') return <MarketingHub />;
  if (path === '/tai-lieu/marketing/tasks') return <MarketingTasks />;
  if (path.startsWith('/tai-lieu/marketing/tasks/')) {
    const taskId = path.split('/tai-lieu/marketing/tasks/')[1];
    return <MarketingTasks initialTaskId={taskId} />;
  }
  if (path === '/tai-lieu/marketing/create') return <MarketingEditor />;
  if (path === '/tai-lieu/quy-che-luong-hdv') return <BlogLayout><InternalDocsTab /></BlogLayout>;
  if (path === '/tai-lieu/quy-trinh-sale-dieu-hanh') return <BlogLayout><QuyTrinhSaleDieuHanhPage /></BlogLayout>;
  if (path.startsWith('/tai-lieu/brand-guideline')) return <BrandGuidelinePage />;
  if (path === '/tai-lieu/bo-nguyen-tac-hanh-xu-nhan-vien') return (
    <MarkdownViewer 
      fileUrl="/docs/bo-nguyen-tac.md" 
      title="Bộ Nguyên Tắc Hành Xử"
      author="Ban Giám Đốc FIT Tour"
      updatedDate="23/04/2026"
      breadcrumbs={[{ label: 'Quy tắc hành xử' }]}
    />
  );
  if (path === '/tai-lieu/dat-ten-tour') return (
    <MarkdownViewer 
      fileUrl="/docs/dat-ten-tour.md?v=2" 
      title="SOP – Chuẩn hóa tên Tour"
      author="Ban Giám Đốc FIT Tour"
      breadcrumbs={[{ label: 'Checklist Điều Hành' }]}
    />
  );
  if (path === '/tai-lieu/zoho-email') return (
    <MarkdownViewer 
      fileUrl="/docs/zoho-email.md" 
      title="Hướng Dẫn Kết Nối Zoho Mail"
      author="FIT Tour IT Support"
      breadcrumbs={[{ label: 'Hướng dẫn Công cụ' }]}
    />
  );
  if (path === '/tai-lieu/chinh-sach-danh-gia') return <ChinhSachDanhGiaPage />;
  if (path === '/tai-lieu/co-che-kpi') return <CoCheKpiPage />;
  if (path === '/tai-lieu/van-ban-co-che-kpi') return (
    <MarkdownViewer 
      fileUrl="/docs/van-ban-co-che-kpi.md" 
      title="Quyết định ban hành cơ chế lương – KPI" 
      author="Ban Giám Đốc" 
      updatedDate="01/01/2026"
      breadcrumbs={[{ label: 'Tài liệu', path: '/tai-lieu' }, { label: 'Biểu mẫu hành chính', path: '/tai-lieu/bieu-mau' }]}
    />
  );
  if (path === '/tai-lieu/quy-tac-dat-ten-quang-cao-meta') return <BlogLayout><SopMetaAdsInfographic /></BlogLayout>;
  const marketingQuickLinks = [
    { title: 'Rule Meta Ads', path: '/tai-lieu/rule-meta-ads', icon: '📜' },
    { title: 'Blueprint Meta Ads', path: '/tai-lieu/blueprint-meta-ads', icon: '🎯' },
    { title: 'SOP Đặt Tên Ads', path: '/tai-lieu/sop-meta-ads', icon: '📝' },
    { title: 'Brand Identity', path: '/tai-lieu/brand-guideline', icon: '🎨' },
    { title: 'Chính Sách Đánh Giá', path: '/tai-lieu/chinh-sach-danh-gia', icon: '⭐' },
    { title: 'HD Đánh Giá Maps', path: 'https://fittour.vn/huong-dan-danh-gia-fit-tour', icon: '📍', external: true }
  ];

  if (path === '/tai-lieu/quy-trinh-thanh-toan-ban-giao-quyet-toan-tour') return (
    <MarkdownViewer 
      markdownContent={QUY_TRINH_THANH_TOAN_TOUR_MARKDOWN}
      title="Quy Trình Thanh Toán, Bàn Giao Quyết Toán Tour"
      author="Kế toán & Điều Hành"
      breadcrumbs={[{ label: 'Kế toán', path: '/tai-lieu/ke-toan' }]}
    />
  );

  if (path === '/tai-lieu/sop-meta-ads') return (
    <MarkdownViewer 
      markdownContent={SOP_META_ADS_MARKDOWN}
      title="SOP – Quy Ước Đặt Tên Meta Ads"
      author="FIT Tour Marketing"
      breadcrumbs={[{ label: 'Marketing', path: '/tai-lieu/marketing' }]}
      quickLinks={marketingQuickLinks}
    />
  );
  if (path === '/tai-lieu/marketing/quy-tac-phan-loai') return (
    <MarkdownViewer 
      markdownContent={QUY_TAC_PHAN_LOAI_LEAD_MARKDOWN}
      title="Quy Tắc Phân Loại & Dọn Dẹp Lead Marketing"
      author="Ban Giám Đốc"
      breadcrumbs={[{ label: 'Lead Marketing', path: '/leads' }]}
    />
  );
  if (path === '/tai-lieu/blueprint-meta-ads') return (
    <MarkdownViewer 
      markdownContent={BLUEPRINT_META_ADS_MARKDOWN}
      title="Blueprint Meta Ads"
      author="FIT Tour Marketing"
      breadcrumbs={[{ label: 'Marketing', path: '/tai-lieu/marketing' }]}
      quickLinks={marketingQuickLinks}
    />
  );
  if (path === '/tai-lieu/rule-meta-ads') return (
    <MarkdownViewer 
      markdownContent={RULE_META_ADS_MARKDOWN}
      title="Rule Meta Ads FIT Tour"
      author="FIT Tour Marketing"
      breadcrumbs={[{ label: 'Marketing', path: '/tai-lieu/marketing' }]}
      quickLinks={marketingQuickLinks}
    />
  );
  if (path === '/tai-lieu/sop-astro-tour') return (
    <MarkdownViewer 
      markdownContent={SOP_ASTRO_TOUR_MARKDOWN}
      title="SOP Chuyển Đổi Trang Tour: Elementor Sang Astro Native"
      author="FIT Tour Developer"
      breadcrumbs={[{ label: 'Tài liệu', path: '/tai-lieu' }]}
    />
  );
  const dispatchQuickLinks = [
    { title: 'Tổng quan Quy trình Lead', path: '/tai-lieu/tong-quan-lead', icon: '🌐' },
    { title: 'SOP Điều Phối Lead', path: '/tai-lieu/sop-dieu-phoi', icon: '🔀' },
    { title: 'SOP Sales & Workplace', path: '/tai-lieu/sop-sales', icon: '💼' }
  ];

  if (path === '/tai-lieu/tong-quan-lead') return (
    <MarkdownViewer 
      markdownContent={SOP_OVERVIEW_MARKDOWN}
      title="Tổng quan Quy trình Xử lý Lead"
      author="Ban Giám Đốc"
      breadcrumbs={[{ label: 'Điều hành', path: '/tai-lieu/dieu-hanh' }]}
      quickLinks={dispatchQuickLinks}
    />
  );
  if (path === '/tai-lieu/sop-dieu-phoi') return (
    <MarkdownViewer 
      markdownContent={SOP_DISPATCH_MARKDOWN}
      title="SOP Điều Phối Lead"
      author="FIT Tour Operations"
      breadcrumbs={[{ label: 'Điều hành', path: '/tai-lieu/dieu-hanh' }]}
      quickLinks={dispatchQuickLinks}
    />
  );
  if (path === '/tai-lieu/sop-sales') return (
    <MarkdownViewer 
      markdownContent={SOP_SALES_MARKDOWN}
      title="SOP Sales & Workplace"
      author="FIT Tour Sales"
      breadcrumbs={[{ label: 'Sale', path: '/tai-lieu/sale' }]}
      quickLinks={dispatchQuickLinks}
    />
  );
  if (path === '/tai-lieu' || path === '/tai-lieu/') return <DocumentsHome />;
  
  if (path === '/tai-lieu/tu-van-ladakh-bu4') {
    return <BlogLayout fullWidth={true} backPath="/tai-lieu" backText="Về lại Tài Liệu"><LadakhConsultingPage /></BlogLayout>;
  }
  
  if (path === '/tai-lieu/tu-van-bhutan-5n4d') {
    return <BlogLayout fullWidth={true} backPath="/tai-lieu" backText="Về lại Tài Liệu"><BhutanConsultingPage /></BlogLayout>;
  }

  // RAG Dynamic Documents
  if (path.match(/^\/tai-lieu\/\d+$/)) return <BlogLayout><RagDocViewer /></BlogLayout>;

  return <PlaceholderPage />;
};

export default DocumentsPage;
